import { newVpaSettings } from '../../_constants/_constants';
import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  hpaConverterField: React.ReactNode;
};

export const HpaConverterSettingsContainer = ({ hpaConverterField }: Props) => {
  const { title, description, docsLinkKey } = vpaSettingsConstants.hpaConverter;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
      isNew={newVpaSettings.includes('hpaConverter')}
    >
      {hpaConverterField}
    </VerticalSettingsForm>
  );
};
